const state = {
  jobvacancy: [],
  jobvacancy_id: [],
  jobtype: [],
  jobexperience: [],
};

export default state;
